import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/customer-api/credit-trend/page', params)

export const getMaxValues = params =>
  request.post('/customer-api/credit-trend/statistics', params)

// 获取图表
// export const getEcherData = () =>
//   request.post('/customer-api/credit-trend/statistics_all')
